import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import { useI18n } from 'next-localization';
import { useFetchFundDetailsPerformanceQuery } from '@/store/fundDetails/services/fundDetailsApi';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import FundDetailsGeneralPerformanceTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsGeneralPerformanceTable';
import useHelpers from 'hooks/helpers';

type Props = {
  title: string;
  footnoteText: string;
  wrapperId: string;
  tableId: string;
  endpoint: string;
  className?: string;
  quarterly?: boolean;
};
const PerformanceTableBase = ({
  tableId,
  footnoteText,
  title,
  wrapperId,
  endpoint,
  className = '',
  quarterly = false,
}: Props) => {
  const { t } = useI18n();
  const { getErrorDictionary } = useHelpers();
  const payload = usePayload();
  const { data, isLoading, error } = useFetchFundDetailsPerformanceQuery({
    ...payload,
    quarterly,
    endpoint,
  });

  return (
    <div className={className}>
      <h4 className="mb-4">{title}</h4>

      {isLoading ? (
        <FundDetailsTabSkeleton />
      ) : error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      ) : data?.content?.performanceSet?.length > 0 ? (
        <FundDetailsGeneralPerformanceTable
          tabData={data.content}
          footnoteText={footnoteText}
          wrapperId={wrapperId}
          tableId={tableId}
        />
      ) : (
        <div className="body-default">{t('noResultsMessage')}</div>
      )}
    </div>
  );
};

export default PerformanceTableBase;
